import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <img 
              src={companyInfo.logo} 
              alt={companyInfo.name}
              className="footer-logo"
            />
            <h3 className="footer-title">{companyInfo.name}</h3>
            <p className="footer-description">
              Votre spécialiste en entretien et aménagement d'espaces verts dans l'Hérault.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Navigation</h4>
            <ul className="footer-links">
              <li><Link to="/" className="footer-link">Accueil</Link></li>
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/about" className="footer-link">À Propos</Link></li>
              <li><Link to="/gallery" className="footer-link">Réalisations</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-heading">Nos Services</h4>
            <ul className="footer-links">
              <li className="footer-link">Tonte de Pelouse</li>
              <li className="footer-link">Taille de Haies</li>
              <li className="footer-link">Aménagement Paysager</li>
              <li className="footer-link">Élagage d'Arbres</li>
              <li className="footer-link">Entretien d'Espaces Verts</li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <Phone className="w-5 h-5" />
                <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}>
                  {companyInfo.phone}
                </a>
              </li>
              <li className="footer-contact-item">
                <Mail className="w-5 h-5" />
                <a href={`mailto:${companyInfo.email}`}>
                  {companyInfo.email}
                </a>
              </li>
              <li className="footer-contact-item">
                <MapPin className="w-5 h-5" />
                <span>{companyInfo.address}</span>
              </li>
            </ul>
            <div className="footer-social">
              <a href="#" className="footer-social-link" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="footer-social-link" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} {companyInfo.name}. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};
